<template>
  <div
    :style="{
      'font-size': size,
    }"
  >
    <span
      :style="{
        color: getColor,
        'font-size': size,
        'font-weight': bold ? 'bold' : 'unset',
        'line-height': size,
      }"
      v-if="showAmount && showAmount < 0"
      >-</span
    ><span
      :style="{
        color: getColor,
        'font-size': size,
        'font-weight': bold ? 'bold' : 'unset',
        'line-height': size,
      }"
      v-if="change && showAmount && showAmount > 0"
      >+</span
    ><span
      :style="{
        color: getColor,
        'font-size': '0.8em',
        'font-weight': bold ? 'bold' : 'unset',
        width: '0.9em !important',
        'line-height': '0.8em',
        display: 'inline-block',
        'line-height': size,
      }"
      v-if="showIcon"
      >￥</span
    ><span
      class="fm-padding-right-3"
      :style="{
        color: getColor,
        'font-size': size,
        'font-weight': bold ? 'bold' : 'unset',
        'white-space': 'nowrap',
        'line-height': size,
      }"
      >{{ formatPrice(showAmount) }}</span
    ><span
      :style="{
        color: 'var(--fm-secondary-text-color)',
        'font-size': '0.8em',
        'font-weight': bold ? 'bold' : 'unset',
        width: '0.7em !important',
        'line-height': '0.8em',
        position: 'relative',
        'line-height': size,
      }"
      v-if="nextAmount && nextAmount != showAmount"
      >至</span
    ><span
      class="fm-padding-right-3"
      :style="{
        color: getColor,
        'font-size': size,
        'font-weight': bold ? 'bold' : 'unset',
        'white-space': 'nowrap',
        'line-height': size,
      }"
      v-if="nextAmount && nextAmount != showAmount"
      >{{ formatPrice(nextAmount) }}</span
    >
  </div>
</template>

<script>
export default {
  name: "FmAmount",
  props: {
    // 是否显示￥
    showIcon: {
      type: Boolean,
      default: true,
    },
    // 显示的金额
    amount: {
      type: [String, Number],
      default: 0,
    },
    // 是否反转金额，仅对amount有效，用于流出金额等情况
    invertAmount: {
      type: Boolean,
      default: false,
    },
    // 显示金额范围时需要输入
    nextAmount: {
      type: [String, Number],
      default: null,
    },
    // 字体大小
    size: {
      type: [String, Number],
      default: "1em",
    },
    // 是否加粗
    bold: {
      type: Boolean,
      default: false,
    },
    // 颜色，优先级大于positiveColor和negativeColor
    color: {
      type: String,
      default: null,
    },
    // 正数颜色
    positiveColor: {
      type: String,
      default: "var(--fm-success-color)",
    },
    // 0 颜色
    zeroColor: {
      type: String,
      default: "var(--fm-warning-color)",
    },
    // 负数颜色
    negativeColor: {
      type: String,
      default: "var(--fm-danger-color)",
    },
    // 是否显示正数金额前面的+
    change: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showAmount() {
      return this.invertAmount ? -this.amount : this.amount;
    },
    getColor() {
      if (this.color) {
        return this.color;
      }
      if (this.showAmount && this.showAmount != 0) {
        return this.showAmount > 0 ? this.positiveColor : this.negativeColor;
      } else {
        return this.zeroColor;
      }
    },
  },
  methods: {
    formatPrice(price) {
      if (price == null || typeof price == "undefined") {
        return 0;
      }
      if (typeof price == "string") {
        price = Number(price);
      }
      if (price < 0) {
        price = -price;
      }
      return price.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/fm/FmAmount.vue